import {Queries} from '../../api/queries';
import Layout from '../Layout';
import ProductEditModal from './ProductEditModal';
import {Box, Button, Icon, Text} from '@sproutsocial/racine';
import {useQuery} from '@tanstack/react-query';
import {SyntheticEvent, useCallback, useState} from 'react';
import type {Product} from 'shared/src/models';

const Products = () => {
	const {data: products, refetch: refetchProducts} = useQuery(Queries.products());

	const [isEditing, setIsEditing] = useState(false);
	const [editingProduct, setEditingProduct] = useState<Product>();

	const onCreateProduct = useCallback(() => {
		setIsEditing(true);
	}, []);

	const onEditProduct = useCallback(
		(event: SyntheticEvent<HTMLElement>) => {
			const productId = event.currentTarget.dataset['productId']!;

			setIsEditing(true);
			setEditingProduct(products!.find((product) => product.id === productId));
		},
		[products],
	);

	const onDoneEditing = useCallback(
		async (didMakeChanges: boolean) => {
			setIsEditing(false);
			setEditingProduct(undefined);

			if (didMakeChanges) {
				await refetchProducts();
			}
		},
		[refetchProducts],
	);

	return (
		<Layout>
			<Layout.Header title='Products'>
				<Button appearance='primary' onClick={onCreateProduct}>
					<Icon name='cart-plus-solid' mr='space.300' /> New
				</Button>
			</Layout.Header>
			<Layout.Body>
				<Box border={500} borderRadius='outer' borderColor='container.border.base' bg='white'>
					<ul style={{listStyleType: 'none'}}>
						{products?.map((product) => (
							<li key={product.id}>
								<Box display='flex' alignItems='center'>
									<Text fontSize={200} fontWeight='semibold' color='text.headline'>
										{product.name}
									</Text>
									<Icon
										name='pencil-to-square-outline'
										ml='space.400'
										color='button.primary.background.base'
										cursor='pointer'
										onClick={onEditProduct}
										data-product-id={product.id}
									/>
								</Box>

								{product.variants && product.variants.length > 0 && (
									<ul style={{listStyleType: 'disc'}}>
										{product.variants.map((variant) => (
											<li key={variant.id}>
												<Text fontSize={200} color='text.body'>
													{variant.description}
												</Text>
											</li>
										))}
									</ul>
								)}
							</li>
						))}
					</ul>
				</Box>

				{isEditing && <ProductEditModal product={editingProduct} onClose={onDoneEditing} />}
			</Layout.Body>
		</Layout>
	);
};

export default Products;
